
import {defineComponent } from 'vue';
import { OioButton} from '@kunlun/vue-ui-antd';
import { exportModelExcelFile } from '../../../utils/excel';

export default defineComponent({
  name: 'customizeViewExport',
  components: {
    OioButton,
  },
  inheritAttrs: false,
  props: {
    rModel:{
      default: () => {}
    },
    rows:{
      default: () => []
    },
  },
  setup(props) {
    const handleExport = () => {
      // @ts-ignore
      exportModelExcelFile(props.rows, props.rModel, {
        filename: `特殊政策商品明细导出_${Date.now()}.xlsx` ,
        customFieldsParser: {
          specialApplyOrderItem(val, index, field, row) {
            return {label: field.label , value: val?.name ?? '' };
          },
        }
      });
    };
    return {
      handleExport
    };
  }
});

